/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capabilities_TitleInputs */

const en_landing_capabilities_title = /** @type {(inputs: Landing_Capabilities_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institutional capabilities`)
};

/**
* | output |
* | --- |
* | "Institutional capabilities" |
*
* @param {Landing_Capabilities_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capabilities_title = /** @type {((inputs?: Landing_Capabilities_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capabilities_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capabilities_title(inputs)
});